module.exports = fox._r("images/slides/urban/slide_1_6.jpg", __webpack_public_path__ + "images/slides/urban/slide_1_6.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/urban/slide_1_6.jpg
// module id = 53
// module chunks = 2